import { useEffect } from 'react';
import { skipToken, useQuery } from '@tanstack/react-query';

import { authenticationAPIService } from '~/api/login';
import { userKeys } from '~/constants/queryKeys';
import { cookieService } from '~/services/cookie-service';
import { initIntercom } from '~/utils/intercom';

export const useInitializeIntercom = () => {
  const isAccessCookie = cookieService.getCookie('access') || null;

  const { data: user } = useQuery({
    queryKey: [userKeys.user, isAccessCookie],
    queryFn: isAccessCookie ? () => authenticationAPIService.getAccount() : skipToken,
    select: (response) => {
      return response.data;
    },
  });

  const loadRegisteredIntercom = async () => {
    if (user.email) {
      const userHashData = await authenticationAPIService.getUserHash();
      const hash = userHashData.data;
      const name = [user.firstName, user.lastName].filter(Boolean).join(' ');

      initIntercom(name, user.email, String(hash));
    }
  };

  useEffect(() => {
    if (window.location.href.includes('localhost')) return;
    if (user?.id) {
      void loadRegisteredIntercom();
    }

    if (!isAccessCookie) {
      // load anonym intercom
      initIntercom();
    }
  }, [user?.id]);
};
